/**
 * Shared tokens for Landon memorial + bibliography routes (console theme).
 */

export const landonSurface =
  "rounded-2xl border border-base-300 bg-base-200/25 backdrop-blur-sm";

export const landonSurfaceNoBorder =
  "rounded-2xl bg-base-200/25 backdrop-blur-sm";

export const landonIconBtn =
  "btn btn-sm btn-ghost border border-base-300 text-base-content hover:border-primary hover:text-primary shrink-0";

export const landonLink =
  "text-primary hover:underline focus:outline-none focus-visible:ring-1 focus-visible:ring-primary rounded";

/** Primary column: width + horizontal padding (add pt/pb per page) */
export const landonColumn =
  "relative mx-auto max-w-5xl px-4 sm:px-6";
